import React, { useContext } from 'react';
export const defaultConfig = {};
export const SelectContext = React.createContext(defaultConfig);
export const useSelect = () => useContext(SelectContext);
